import AppModule from "../../services/App/AppModule.js";
import AppModuleType from "../../services/App/AppModuleType.js";

export default {
  // required in model
  Module: AppModule.StockSpecialPrice,
  ModuleType: {
    SearchList: AppModuleType.SearchList
  },

  /*** related ***/

  /*** property ***/

  Search: {
    Fields: ["Name", "SKU"]
  },

  /*** method ***/

  /*** external ***/
}